import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { PortableText } from "@portabletext/react";
import { sanity } from "../../lib/sanityClient";
import { urlFor } from "../../lib/imageUrl";

const query = `*[_type == "post" && slug.current == $slug][0]{
  _id, title, body,
  "publishedAt": coalesce(publishedAt, _createdAt),
  "tags": select(
    defined(categories) => categories[]->title,
    defined(tags) => tags,
    []
  ),
  "cover": coalesce(image, coverImage, mainImage){asset, alt}
}`;

function fmt(iso) {
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric", month: "short", day: "numeric"
  });
}

const ptComponents = {
  block: {
    normal: ({ children }) => (
      <p className="inter-text" style={{ textAlign: "left", whiteSpace: "pre-line" }}>
        {children}
      </p>
    ),
  },
  list: {
    bullet: ({ children }) => <ul style={{ paddingLeft: "1.25rem" }}>{children}</ul>,
    number: ({ children }) => <ol style={{ paddingLeft: "1.25rem" }}>{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => (
      <li className="inter-text" style={{ textAlign: "left", whiteSpace: "pre-line" }}>
        {children}
      </li>
    ),
    number: ({ children }) => (
      <li className="inter-text" style={{ textAlign: "left", whiteSpace: "pre-line" }}>
        {children}
      </li>
    ),
  },
};

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    sanity.fetch(query, { slug }).then(setPost).catch(console.error);
  }, [slug]);

  if (!post) return null;

  return (
    <section className="blog-section">
      <Container>
        <p style={{ marginBottom: "0.5rem" }}>
          <Link to="/blog">Home / Blog</Link>
        </p>

        <h1 className="project-heading" style={{ marginTop: 0 }}>
          {post.title}
        </h1>

        <div className="post-meta" style={{ color: "#555", marginBottom: "0.75rem" }}>
          {post.publishedAt && (
            <small style={{ fontWeight: 600 }}>{fmt(post.publishedAt)}</small>
          )}
          {post.tags?.length ? (
            <span style={{ marginLeft: "0.5rem" }}>
              {post.tags.map((t, i) => (
                <span key={i} className="tag-pill" style={{ marginLeft: i ? ".35rem" : 0 }}>
                  {t}
                </span>
              ))}
            </span>
          ) : null}
        </div>

        {post.cover?.asset && (
          <div style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
            <img
              src={urlFor(post.cover).width(1200).url()}
              alt={post.cover?.alt || ""}
              style={{ width: "100%", height: "auto", borderRadius: "8px" }}
            />
          </div>
        )}

        <article className="blog-post">
          <PortableText value={post.body} components={ptComponents} />
        </article>
      </Container>
    </section>
  );
}
